import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Title, TextInput } from './Styled';

class Input extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fieldActive: false
        };
    }
    handleOnFocus = () => {
        this.setState({ fieldActive: !this.state.fieldActive});
    }

    handleOnBlur = () => {
        this.setState({ fieldActive: false});
    }
    render() {
        const { label, id, name, placeholder, value, onChange, maxLength } = this.props;
        return (
            <Wrapper fieldActive={this.state.fieldActive} onFocus={this.handleOnFocus} onBlur={this.handleOnBlur}>
                <Title htmlFor={name}>{label}</Title>
                <TextInput value={value} onChange={onChange} maxLength={maxLength} placeholder={placeholder} name={name} type="text" id={id}/>
            </Wrapper>
        );
    }
}

Input.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    maxLength: PropTypes.string,
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/common/Input/Input.js